import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { Provider } from 'react-redux'
import { ClearCacheProvider } from 'react-clear-cache'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'

if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_URL,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
}

ReactDOM.render(
  <React.StrictMode>
    {process.env.NODE_ENV === 'production' ? (
      <ClearCacheProvider duration={5000}>
        <Provider store={store}>
          <App />
        </Provider>
      </ClearCacheProvider>
    ) : (
      <Provider store={store}>
        <App />
      </Provider>
    )}
  </React.StrictMode>,
  document.getElementById('root'),
)

reportWebVitals()
